import {
  AnalyticsState,
  EventActions,
  EventCategories,
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

type Category = 'make' | 'model'

const trackOnFilterChange =
  (trackEvent: AnalyticsState['trackEvent']) =>
  (name: string, filterSection: Category) => {
    if (name === '') {
      name = `All ${filterSection}s`
    }
    const data = {
      event: {
        name: EventNames.click,
        category: EventCategories.button,
        action: EventActions.filter,
        label: name,
        section: filterSection,
      },
    }

    trackEvent({
      eventName: `Car reviews hub - filter ${filterSection}`,
      data,
      type: TrackingEventTypes.ADOBE,
    })
  }

const trackOnReviewCardClick =
  (trackEvent: AnalyticsState['trackEvent']) => (reviewTitle: string) => {
    const data = {
      event: {
        name: EventNames.click,
        category: EventCategories.button,
        action: EventActions.navigate,
        label: reviewTitle,
      },
    }

    trackEvent({
      eventName: 'Car reviews hub - click review card',
      data,
      type: TrackingEventTypes.ADOBE,
    })
  }

const trackNoResultsFound =
  (trackEvent: AnalyticsState['trackEvent']) => (name: string) => {
    const data = {
      event: {
        name: EventNames.impression,
        category: EventCategories.reviews,
        action: EventActions.noReviewsFound,
        label: name,
      },
    }

    trackEvent({
      eventName: 'Car reviews hub - No car reviews found',
      data,
      type: TrackingEventTypes.ADOBE,
    })
  }

export const useCarReviewsHubTracking = () =>
  useAnalytics(({ trackEvent }) => ({
    trackOnFilterChange: trackOnFilterChange(trackEvent),
    trackOnReviewCardClick: trackOnReviewCardClick(trackEvent),
    trackNoResultsFound: trackNoResultsFound(trackEvent),
  }))
